import { Component, input, output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-language-selector',
  imports: [FontAwesomeModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent {
  readonly language = input<string>('EN');
  readonly languageChange = output<string>();

  faGlobe = faGlobe;
  langMenu = false;

  toggleLangMenu() {
    this.langMenu = !this.langMenu;
  }

  setLanguage(lang: string) {
    this.languageChange.emit(lang);
    this.toggleLangMenu();
  }
}
